module.exports = "/images/everestPath8.png?4155c91a9a2ba3c33c5a0f6965032380";